import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  notification: {
    padding: theme.spacing(0, 1.5),
    margin: '5.6px 12px 0px 8px',
    fontSize: 14,
    textTransform: 'none',
    boxShadow: 'none',
  },
}));
